
export const phoneKeyPress = (event: any) => {
    if(!isNumberKey(event) && !isModifierKey(event)){
        event.preventDefault();
        return false;
    }else{
        return true;
    }
}

export const phoneKeyUp = (e: any) => {
    e.target.value = formatToPhone(e.target.value);
    return e;
}

// Detect if a value pressed from event is a number key
export const isNumberKey = (event: any) => {
    let key: number = (event.which) ? event.which : event.keyCode;
    return((key >= 48 && key <= 57) || (key >= 96 && key <= 105));
}

const isModifierKey = (event: any) => {
    const key = event.keyCode;
    return (event.shiftKey || key === 35 || key === 36) || // Allow Shift, Home, End
        (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
        (key > 36 && key < 41) || // Allow left, up, right, down
        (
            // Allow Ctrl/Command + A,C,V,X,Z
            (event.ctrlKey === true || event.metaKey === true) &&
            (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
        )
};

export const formatToPhone = (value: string):string => {
    const input = value.replace(/\D/g,'').substring(0,10); // First ten digits of input only
    const areaCode = input.substring(0,3);
    const middle = input.substring(3,6);
    const last = input.substring(6,10);
    if(input.length > 6){return `(${areaCode})${middle}-${last}`;}
    else if(input.length > 3){return `(${areaCode})${middle}`;}
    else if(input.length > 0){return `(${areaCode}`;}
    else {
        return "";
    }
}

// Phone formatting function
export const phoneFormat = (e: any): any => {
    let input = e.target.value;
    // Removes all characters that are not a number
    input = input.replace(/\D/g,'');
    // Trim the remaining input to ten characters, to preserve phone number format
    input = input.substring(0,10);
    // Saving size to compare later
    var size = input.length;
    // First 4 characters add parenthesis 
    if(size < 4){
        input = '('+input;
    }else if(size < 7){
        input = '('+input.substring(0,3)+')'+input.substring(3,6);
    }else{
        input = '('+input.substring(0,3)+')'+input.substring(3,6)+'-'+input.substring(6,9);
    }
    // Set value of target to formatted input
    e.target.value = input;
    // returning full event element to do something with it such as preventDefault, etc.
    return e; 
}

export const formatUSD = (value: string | number) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(Number(value));
}

// Nearest 1/4
export const nearestFourthHour = (num: number): number => {
    return Math.ceil((num / 60) / 0.25) * 0.25;
}